import { RiskObservationSource } from "./riskObservationDialog/RiskObservationDialog.types";

export enum RiskObservationStatus {
    New = 1,
    Converted = 2,
    Archived = 3,
}

export interface RiskObservationViewModel {
    id: string;
    name: string;
    description?: string;
    source: RiskObservationSource;
    observedBy: string;
    observedByEmail?: string;
    observedDate: string;
    status: RiskObservationStatus;
    created: string;
    canBeConvertedToRiskScenario: boolean;
    canBeConvertedToIncident: boolean;
}

// The table searches and sorts on row properties, so what the cells display is materialised here
// instead of being composed inside the cell: "Name (email)" for Observed by, and the translated status
// text, which is what the user sees on the chip and therefore what they search for. The Status column
// still sorts on the numeric status so the order follows the observation lifecycle, not the alphabet.
export interface RiskObservationRow extends RiskObservationViewModel {
    observedByWithEmail: string;
    statusText: string;
}

export interface ObservationExportHeader {
    header: string;
    column: string;
}
